import React from 'react';
import "./Projectcards.css"
import Tilt from 'react-parallax-tilt';
import CustomButton from './Custombtn';

const ProjectCards = ({ projectName, projectYear, universityName, projectDescription, skills,href }) => {
  return (
    <Tilt>
    <div className="project-card">
      <div className="card-header">
        <h2>{projectName}</h2>
        <p>{projectYear}</p>
      </div>
      <div className="card-body">
        <p className="university">{universityName}</p>
        <p className="description">{projectDescription}</p>
        <div className="skills">
          {skills}
        </div>
      </div>
      <div className='btn-container'>
          <CustomButton btntitle="View-Project" href={href}/>
      </div>
    </div>
   </Tilt>
  );
};

export default ProjectCards;
